(()=>{'use strict';const C=window.SOVAH_CERT_DATA;if(!C)return;const h=()=>location.pathname.replace(/\/+$/,'').split('/').pop()||'',n=s=>String(s||'').replace(/\s+/g,' ').trim().toLowerCase();function host(){let x=document.querySelector('[data-sovah-cert-host]');if(x)return x;const labels=['vegan','gluten free','nut free','cosmos natural','cosmos organic','dermatologically tested'];x=[...document.querySelectorAll('main .shopify-section,main .section-wrapper')].find(e=>{if(e.querySelector('[data-sovah-routine-standards]'))return false;if(e.closest('[id*="__main"]')||e.querySelector('product-information,product-form-component'))return false;const t=n(e.textContent),m=labels.filter(l=>t.includes(l)).length;return m>=2||((t.includes('certification')||t.includes('standards'))&&m)});if(x){x.dataset.sovahCertHost='true';return x}const i=document.querySelector('main [data-sovah-ingredients]');if(!i?.parentElement)return null;x=document.createElement('div');x.className='shopify-section';x.dataset.sovahCertHost='true';i.insertAdjacentElement('afterend',x);return x}function copy(k,b){if(k==='al')return b?'Allergen Label Free is documented for every product in this routine. This does not mean allergen-free.':'Allergen Label Free is documented for this product. This does not mean allergen-free.';if(k==='cn'||k==='co')return b?`${C.a[k][0]} certification is documented for every product in this routine.`:`${C.a[k][0]} certification is documented for this product.`;return b?`${C.a[k][0]} is documented for every product in this routine.`:`${C.a[k][0]} is documented for this product.`}function card(k,b){const a=C.a[k],img=a[1].startsWith('http')?`<img class="sovah-routine-standards__logo" src="${a[1]}" alt="${a[2]}" loading="lazy">`:`<span aria-label="${a[2]}">${a[1]}</span>`;return `<article class="sovah-routine-standards__card"><div class="sovah-routine-standards__mark">${img}</div><div><h3 class="sovah-routine-standards__name">${a[0]}</h3><p class="sovah-routine-standards__copy">${copy(k,b)}</p></div></article>`}function render(){const key=h(),d=C.d[key];if(!d)return;const old=document.querySelector('[data-sovah-routine-standards]');if(old?.dataset.version===C.v&&old.dataset.handle===key)return;const x=old?.closest('[data-sovah-cert-host],.shopify-section,.section-wrapper')||host();if(!x)return;const b=d[0]==='b',id='sovah-standards-'+key;x.innerHTML=`<section class="sovah-routine-standards" data-sovah-routine-standards data-version="${C.v}" data-handle="${key}" aria-labelledby="${id}"><div class="sovah-routine-standards__inner"><header class="sovah-routine-standards__header"><p class="sovah-routine-standards__eyebrow">${b?'Routine standards':'Formula standards'}</p><h2 class="sovah-routine-standards__title" id="${id}">${b?'Standards across the full routine':'Standards behind this formula'}</h2><p class="sovah-routine-standards__intro">${b?`Only labels documented for every one of the ${d[1]} products are shown.`:'Labels shown below reflect the documented product specifications.'}</p></header><div class="sovah-routine-standards__grid">${d[2].map(k=>card(k,b)).join('')}</div></div></section>`}let t;const go=()=>{clearTimeout(t);t=setTimeout(render,80)};document.readyState==='loading'?document.addEventListener('DOMContentLoaded',render,{once:true}):render();document.addEventListener('shopify:section:load',go);new MutationObserver(go).observe(document.documentElement,{childList:true,subtree:true})})();
;(() => {
  'use strict';
  const locale = (document.documentElement.lang || 'en').toLowerCase().split('-')[0];
  const fixed = {
    nl: {
      'Formula standards':'Formulestandaarden',
      'Routine standards':'Routinestandaarden',
      'Standards behind this formula':'Standaarden achter deze formule',
      'Standards across the full routine':'Standaarden voor de volledige routine',
      'Labels shown below reflect the documented product specifications.':'De onderstaande keurmerken zijn gebaseerd op de vastgelegde productspecificaties.',
      'Vegan':'Vegan',
      'Gluten Free':'Glutenvrij',
      'Nut Free':'Notenvrij',
      'Dermatologically tested':'Dermatologisch getest','Fragrance Free':'Parfumvrij','Allergen Label Free':'Vrij van verplichte allergenenvermelding'
    },
    de: {
      'Formula standards':'Formelstandards',
      'Routine standards':'Routinestandards',
      'Standards behind this formula':'Standards dieser Formel',
      'Standards across the full routine':'Standards der gesamten Routine',
      'Labels shown below reflect the documented product specifications.':'Die unten gezeigten Kennzeichnungen entsprechen den dokumentierten Produktspezifikationen.',
      'Vegan':'Vegan',
      'Gluten Free':'Glutenfrei',
      'Nut Free':'Nussfrei',
      'Dermatologically tested':'Dermatologisch getestet','Fragrance Free':'Parfümfrei','Allergen Label Free':'Ohne deklarationspflichtige Allergene'
    },
    fr: {
      'Formula standards':'Normes de la formule',
      'Routine standards':'Normes de la routine',
      'Standards behind this formula':'Normes de cette formule',
      'Standards across the full routine':'Normes de la routine complète',
      'Labels shown below reflect the documented product specifications.':'Les labels ci-dessous correspondent aux spécifications documentées du produit.',
      'Vegan':'Végane',
      'Gluten Free':'Sans gluten',
      'Nut Free':'Sans fruits à coque',
      'Dermatologically tested':'Testé dermatologiquement','Fragrance Free':'Sans parfum','Allergen Label Free':'Sans allergènes à déclarer'
    }
  }[locale];
  if (!fixed) return;
  const names = {
    nl:{'vegan':'vegan','gluten free':'glutenvrij','nut free':'notenvrij','cosmos natural':'COSMOS Natural-gecertificeerd','cosmos organic':'COSMOS Organic-gecertificeerd','dermatologically tested':'dermatologisch getest'},
    de:{'vegan':'vegan','gluten free':'glutenfrei','nut free':'nussfrei','cosmos natural':'COSMOS Natural-zertifiziert','cosmos organic':'COSMOS Organic-zertifiziert','dermatologically tested':'dermatologisch getestet'},
    fr:{'vegan':'végane','gluten free':'sans gluten','nut free':'sans fruits à coque','cosmos natural':'certifié COSMOS Natural','cosmos organic':'certifié COSMOS Organic','dermatologically tested':'testé dermatologiquement'}
  }[locale];
  const sentence = (source) => {
    const m = source.match(/^(.+) is documented for this product\.$/i);
    if (!m) return null;
    const label = names[m[1].toLowerCase()] || m[1];
    if (locale === 'nl') return 'Voor dit product vastgelegd als ' + label + '.';
    if (locale === 'de') return 'Für dieses Produkt als ' + label + ' dokumentiert.';
    return 'Documenté pour ce produit comme ' + label + '.';
  };
  let queued=false;
  const apply=()=>{
    queued=false;
    document.querySelectorAll('[data-sovah-routine-standards] *').forEach(el=>{
      if(el.children.length)return;
      const source=(el.textContent||'').replace(/\s+/g,' ').trim();
      const translated=fixed[source]||sentence(source);
      if(translated)el.textContent=translated;
    });
  };
  const queue=()=>{if(queued)return;queued=true;requestAnimationFrame(apply)};
  document.readyState==='loading'?document.addEventListener('DOMContentLoaded',queue):queue();
  new MutationObserver(queue).observe(document.documentElement,{childList:true,subtree:true});
})();

;(() => {
  'use strict';

  const locale = (document.documentElement.lang || 'en').toLowerCase().split('-')[0];
  if (locale !== 'nl' && locale !== 'de') return;

  const labels = {
    nl: {
      'Vegan': 'Vegan',
      'Gluten Free': 'Glutenvrij',
      'Nut Free': 'Notenvrij',
      'COSMOS Natural': 'COSMOS Natural-gecertificeerd',
      'COSMOS Organic': 'COSMOS Organic-gecertificeerd',
      'Dermatologically tested': 'Dermatologisch getest',
      'Fragrance Free': 'Parfumvrij',
      'Allergen Label Free': 'Vrij van verplichte allergenenvermelding'
    },
    de: {
      'Vegan': 'Vegan',
      'Gluten Free': 'Glutenfrei',
      'Nut Free': 'Nussfrei',
      'COSMOS Natural': 'COSMOS Natural-zertifiziert',
      'COSMOS Organic': 'COSMOS Organic-zertifiziert',
      'Dermatologically tested': 'Dermatologisch getestet',
      'Fragrance Free': 'Parfümfrei',
      'Allergen Label Free': 'Ohne deklarationspflichtige Allergene'
    }
  }[locale];

  const localizeStandardsCopy = (source) => {
    const certification = source.match(/^(.+) certification is documented for every product in this routine\.$/i);
    const standard = source.match(/^(.+) is documented for every product in this routine\.$/i);
    const label = (certification || standard)?.[1];
    if (!label) return null;
    const translatedLabel = labels[label] || label;
    if (locale === 'nl') return translatedLabel + ' is voor ieder product in deze routine vastgelegd.';
    return translatedLabel + ' ist für jedes Produkt dieser Routine dokumentiert.';
  };

  const apply = () => {
    document.querySelectorAll('.sovah-routine-combined-card__standards').forEach((element) => {
      element.textContent = element.textContent
        .split(' · ')
        .map((label) => labels[label.trim()] || label.trim())
        .join(' · ');
    });

    document.querySelectorAll('[data-sovah-routine-standards]').forEach((section) => {
      const intro = section.querySelector('.sovah-routine-standards__intro');
      if (intro && /^Only labels documented for every one of the \d+ products are shown\.$/.test(intro.textContent.trim())) {
        intro.textContent = locale === 'nl'
          ? 'Alleen keurmerken die voor ieder product in deze routine zijn vastgelegd, worden getoond.'
          : 'Es werden nur Kennzeichnungen gezeigt, die für jedes Produkt dieser Routine dokumentiert sind.';
      }

      section.querySelectorAll('.sovah-routine-standards__copy').forEach((element) => {
        const translated = localizeStandardsCopy(element.textContent.trim());
        if (translated) element.textContent = translated;
      });
    });

    document.querySelectorAll('.sovah-patch-test').forEach((element) => {
      const heading = element.querySelector('strong');
      const paragraph = element.querySelector('p');
      if (heading) heading.textContent = locale === 'nl' ? 'Patchtest' : 'Patch-Test';
      if (paragraph) {
        paragraph.textContent = locale === 'nl'
          ? 'Test ieder product vóór het eerste volledige gebruik afzonderlijk op een klein stukje huid. Introduceer één nieuw product tegelijk en stop bij aanhoudende irritatie.'
          : 'Testen Sie jedes Produkt vor der ersten großflächigen Anwendung einzeln auf einer kleinen Hautstelle. Führen Sie jeweils nur ein neues Produkt ein und beenden Sie die Anwendung bei anhaltender Reizung.';
      }
    });
  };

  let queued = false;
  const queue = () => {
    if (queued) return;
    queued = true;
    requestAnimationFrame(() => {
      queued = false;
      apply();
    });
  };

  document.readyState === 'loading'
    ? document.addEventListener('DOMContentLoaded', queue, { once: true })
    : queue();
  new MutationObserver(queue).observe(document.documentElement, { childList: true, subtree: true });
})();
